import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import { Carousel } from 'react-responsive-carousel';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import LinearProgress from '@mui/material/LinearProgress';
import Paper from '@mui/material/Paper';
import Button from '@mui/material/Button';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import MenuItem  from '@mui/material/MenuItem';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Checkbox from '@mui/material/Checkbox';
import FormGroup from '@mui/material/FormGroup';
import Switch from '@mui/material/Switch';
import FormHelperText from '@mui/material/FormHelperText';
import FormControlLabel from '@mui/material/FormControlLabel';
import TextareaAutosize from '@mui/material/TextareaAutosize';
import Skeleton from '@mui/material/Skeleton';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import PropTypes from 'prop-types';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import dayjs from 'dayjs';
import { Icon } from '@iconify/react';
import { useDeviceProfileQuery, useSingleAppModeMutation, useDeviceNetworkChangeMutation, useChangeDeviceNameMutation, useRefreshDeviceDetailMutation, useRefreshDeviceProfileMutation, useDeviceSearchMutation, useReplaceDeviceMutation, useSyncTagsMutation, useGetUserAccessQuery } from '../../../services/dvagent';
import { getToken } from '../../../services/LocalStorageService';
import { Toaster } from '../attributes';

const cellStyle = {
    borderBottom: 'none',
    paddingY: 1,   
};

function LinearProgressWithLabel(props) {
    return (
        <Box sx={{ display: "flex", alignItems: "center" }}>
        <Box sx={{ width: "100%", mr: 1 }}>
            <LinearProgress sx={{height:'15px'}} variant="determinate" {...props} />
        </Box>
        <Box sx={{ minWidth: 35 }}>
            <Typography variant="body2" color="text.secondary">{`${Math.round(
            props.value
            )}%`}</Typography>
        </Box>
        </Box>
    );
}

LinearProgressWithLabel.propTypes = {
    props: PropTypes.string.isRequired
}

function formatTimestamp(timestamp) {
    const date = new Date(timestamp * 1000);
    return date.toUTCString().slice(0, -4);
}
 
export default function Profile({deviceProfile}) {

    const location = useLocation();
    const [loading, setLoading] = useState(true);
    const [profile, setProfile] = useState([]);
    const [haveDeviceReplaceAccess, setHaveDeviceReplaceAccess] = useState(false);
    const [haveUpdateTagAccess, setHaveUpdateTagAccess] = useState(false);
    const [haveMigrateDeviceNetworkAccess, setHaveMigrateDeviceNetworkAccess] = useState(false);
    const [userNetwork, setUserNetwork] = useState([]);
    const [singleAppModeProfile, setSingleAppModeProfile] = useState('');
    const [maintenanceAppModeProfile, setMaintenanceAppModeProfile] = useState('');
    const [deviceNetwork, setDeviceNetwork] = useState('');
    const [deviceNetworkError, setDeviceNetworkError] = useState('');
    const [singleAppEnable, setSingleAppEnable] = useState(false);
    const [device, setDevice] = useState([]);
    const [open, setOpen] = useState(false);
    const [openReplace, setOpenReplace] = useState(false);
    const [openDoc, setOpenDoc] = useState(false);
    const [popupTitle, setPopupTitle] = useState('');
    const [popupLogo, setPopupLogo] = useState('');
    const [popupWidth, setPopupWidth] = useState(0);
    const [isEditMode, setIsEditMode] = useState(false);
    const [isEditTagMode, setIsEditTagMode] = useState(false);
    const [editedName, setEditedName] = useState("");
    const [deviceTag, setDeviceTag] = useState([]);
    const [deviceTagParam, setDeviceTagParam] = useState([]);
    const [deviceTagPopup, setDeviceTagPopup] = useState(false);
    const [installedApp, setInstalledApp] = useState([]);
    const [newDevice, setNewDevice] = useState("");
    const [newDeviceSerial, setNewDeviceSerial] = useState("");
    const [newDeviceNetwork, setNewDeviceNetwork] = useState("");
    const [newDeviceSerialError, setNewDeviceSerialError] = useState("");
    const [message, setMessage] = useState("To troubleshoot iPad settings");
    const [remark, setRemark] = useState("To troubleshoot iPad settings");
    const [deviceNote, setDeviceNote] = useState("");
    const [deviceRemark, setDeviceRemark] = useState("");
    const [refreshLoader, setRefreshLoader] = useState("Refresh");
    const [tagModify] = useSingleAppModeMutation();
    const [syncTagsList] = useSyncTagsMutation();
    const [changeDeviceNetwork] =useDeviceNetworkChangeMutation();
    const [changeDeviceName] = useChangeDeviceNameMutation();
    const [refreshDeviceDetail] = useRefreshDeviceDetailMutation();
    const [refreshDeviceProfile] = useRefreshDeviceProfileMutation();
    const [searchDevice] = useDeviceSearchMutation();
    const [replaceDevice] = useReplaceDeviceMutation();
    const { data:deviceProfileData, isSuccess:deviceProfileIsSuccess, error:deviceProfileError } = useDeviceProfileQuery({"name":deviceProfile.state.location.state.name, "propertyId":deviceProfile.state.location.state.property_id, "networkId":deviceProfile.state.location.state.network_id, "deviceId":deviceProfile.state.row.id, "serial":deviceProfile.state.row.serialNumber, "organisationId":deviceProfile.state.location.state.organisation_id ,"token":getToken(), "location":location});
    const { data:userAccessData, isSuccess:userAccessIsSuccess, error:userAccessError } = useGetUserAccessQuery({"token":getToken(), "id":deviceProfile.state.location.state.property_id, "location":location});
    const theme = useTheme();
    const navigate = useNavigate();
    const data = deviceProfile.state.location.state
    const [toasterData, setToasterData] = useState({
        trigger: false,
        status: true,
        symbol: '✔',
        message: '',
    });
    const images = [
        '../../assets/app/step-1.png',
        '../../assets/app/step-2.png',
        '../../assets/app/step-3.png',
        '../../assets/app/step-4.png',
      ];

    const handleDocOpen = () => {
        setOpenDoc(true);
    };

    const handleCheckboxChange = (event) => {
        setRemark('');
        setMessage(event.target.name);
        if (event.target.name!=="Other"){
            setRemark(event.target.name);
        }
    };

    const handleDeviceReplaceCheckbox = (event) => {
        setDeviceRemark('');
        setDeviceNote(event.target.value);
        if (event.target.name!=="Other"){
            setDeviceRemark(event.target.value);
        }
    };

    const handleClose = (event) => {
        setOpen(false);
        setOpenReplace(false);
        setOpenDoc(false);
    };

    const handleChangeNetwork = async () => {
        setOpen(false);
        const actualData = {
            data:{
                "newNetwork": deviceNetwork,
                "serials": [
                    device.serialNumber
                ]
            },
            message: remark,
            networkId: deviceProfile.state.location.state.network_id,
            propertyId: deviceProfile.state.location.state.property_id,
            token: getToken()
          }
          const res = await changeDeviceNetwork(actualData);
          if (res.error) {
            if (res.error.status===500) {
                showToast(false, 'ⓘ', 'Something went wrong, please try again');
            } else if (res.error.status===401) {
                showToast(false, 'ⓘ', 'Access Denied');
            } else {
                showToast(false, 'ⓘ', 'Something went wrong, please try again');
            }
          }
          if (res.data) {
            showToast(true, '✔', 'Device network migrated');
            setTimeout(() => {
              setOpen(false);
              navigate('/cloud/devices', { state: data });
            }, 2500);
          } 
          if (res.data===null) {
            showToast(true, '✔', 'Device network migrated');
            setTimeout(() => {
              setOpen(false);
              navigate('/cloud/devices', { state: data });
            }, 2500);
          }
    };

    const handleAskChangeNetwork = () => {
        if (!deviceNetwork){
            setDeviceNetworkError("Please select network");
            return;
        }
        if (!haveMigrateDeviceNetworkAccess){
            showToast(false, 'ⓘ', 'Access Denied');
            return
        }
        setSingleAppEnable(false);
        setRemark("To troubleshoot iPad settings");
        setPopupTitle("Reason for device network migration");
        setPopupLogo("../../assets/app/ask.gif");
        setPopupWidth(0);
        setOpen(true); 
    };

    const handleAskSingleAppModePopup = (event) => {
        if (!haveUpdateTagAccess){
            showToast(false, 'ⓘ', 'Access Denied');
            return
        }
        setSingleAppEnable(event);
        setDeviceTagPopup(false);
        if (event === true){
            setRemark("To troubleshoot iPad settings");
            setSingleAppEnable(true);
            setPopupTitle("Change device mode as single app mode");
            setPopupLogo("../../assets/app/ask.gif");
            setPopupWidth(110);
        } else {
            setRemark("To troubleshoot iPad settings");
            setSingleAppEnable(true);
            setPopupTitle("Purpose of disabling single app mode");
            setPopupLogo("../../assets/app/ask.gif");
            setPopupWidth(0);
        }
        setOpen(true);
    };

    const handleAskUpdateTagPopup = () => {
        setRemark("To troubleshoot iPad settings");
        setSingleAppEnable(false);
        setDeviceTagPopup(true);
        setPopupTitle("Purpose of update device tags");
        setPopupLogo("../../assets/app/ask.gif");
        setPopupWidth(0);
        setOpen(true);
    };

    const handleUpdateTag = async () => {
        setOpen(false);
        setDeviceTagPopup(false);
        setSingleAppEnable(false);
        setIsEditTagMode(false);
        const actualData = {
            data: {
              "tags": deviceTagParam,
              "updateAction": "update",
              "serials": [
                  device.serialNumber
              ]
            },
            message: remark,
            propertyId:deviceProfile.state.location.state.property_id,
            networkId: deviceProfile.state.location.state.network_id,
            token: getToken()
          }
          const res = await tagModify(actualData);
          if (res.error) {
            if (res.error.status===500) {
                showToast(false, 'ⓘ', 'Something went wrong, please try again');
            } else if (res.error.status===401) {
                showToast(false, 'ⓘ', 'Access Denied');
            } else {
                showToast(false, 'ⓘ', 'Something went wrong, please try again');
            }
          }
          if (res.data) {
            setDeviceTagPopup(false);
            setSingleAppEnable(false);
            showToast(true, '✔', 'Device tag modified');
            refreshDeviceProfileData();
            setIsEditTagMode(false);
            setOpen(false);
            setTimeout(() => {
              handleRefresh();
              refreshDeviceProfileData();
            }, 30000);
          } 
          if (res.data===null) {
            setDeviceTagPopup(false);
            setSingleAppEnable(false);
            showToast(true, '✔', 'Device tag modified');
            refreshDeviceProfileData();
            setIsEditTagMode(false);
            setOpen(false);
            setTimeout(() => {
              handleRefresh();
              refreshDeviceProfileData();
            }, 30000);
          }
    };

    const handleSingleAppMode = async (mode) => {
        setOpen(false);
        setSingleAppEnable(false);
        const actualData = {
          data: {
            "tags": [
                singleAppModeProfile
            ],
            "updateAction": mode,
            "serials": [
                device.serialNumber
            ]
          },
          message: remark,
          propertyId:deviceProfile.state.location.state.property_id,
          networkId: deviceProfile.state.location.state.network_id,
          token: getToken()
        }
        const res = await tagModify(actualData);
        if (res.error) {
            if (res.error.status===500) {
                showToast(false, 'ⓘ', 'Something went wrong, please try again');
            } else if (res.error.status===401) {
                showToast(false, 'ⓘ', 'Access Denied');
            } else {
                showToast(false, 'ⓘ', 'Something went wrong, please try again');
            }
        }
        if (res.data) {
            setSingleAppEnable(false);
            showToast(true, '✔', 'Single app mode tag modified');
            refreshDeviceProfileData();
            setOpen(false);
            setTimeout(() => {
                handleRefresh();
                refreshDeviceProfileData();
            }, 30000);
        } 
        if (res.data===null) {
            setSingleAppEnable(false);
            showToast(true, '✔', 'Single app mode tag modified');
            refreshDeviceProfileData();
            setOpen(false);
            setTimeout(() => {
              handleRefresh();
              refreshDeviceProfileData();
            }, 30000);
        }
    };

    const handleMaintenanceAppMode = async (mode) => {
        const actualData = {
          data: {
            "tags": [
                maintenanceAppModeProfile
            ],
            "updateAction": mode,
            "serials": [
                device.serialNumber
            ]
          },
          message: remark,
          propertyId:deviceProfile.state.location.state.property_id,
          networkId: deviceProfile.state.location.state.network_id,
          token: getToken()
        }
        const res = await tagModify(actualData);
        if (res.error) {
            if (res.error.status===500) {
                showToast(false, 'ⓘ', 'Something went wrong, please try again');
            } else if (res.error.status===401) {
                showToast(false, 'ⓘ', 'Access Denied');
            } else {
                showToast(false, 'ⓘ', 'Something went wrong, please try again');
            }
        }
        if (res.data) {
          setSingleAppEnable(false);
          showToast(true, '✔', 'Maintenance app mode tag modified');
          refreshDeviceProfileData();
          setOpen(false);
          setTimeout(() => {
            handleRefresh();
            refreshDeviceProfileData();
          }, 30000);
        } 
        if (res.data===null) {
            setSingleAppEnable(false);
            showToast(true, '✔', 'Maintenance app mode tag modified');
            refreshDeviceProfileData();
            setOpen(false);
            setTimeout(() => {
              handleRefresh();
              refreshDeviceProfileData();
            }, 30000);
        }
    };
  
    const handleEditClick = () => {
        if (!haveUpdateTagAccess || !haveDeviceReplaceAccess || !haveMigrateDeviceNetworkAccess){
            showToast(false, 'ⓘ', 'Access Denied');
            return
        }
        setIsEditMode(true);
    };

    const handleEditTagClick = () => {
        if (!haveUpdateTagAccess){
            showToast(false, 'ⓘ', 'Access Denied');
            return
        }
        setIsEditTagMode(true);
    };

    const handleCloseEditTagClick = () => {
        setIsEditTagMode(false);
    };

    const filterSelectedOptions = (options, value) => {
        return options.filter((option) => value.indexOf(option) === -1);
    };
    
    const handleSaveClick = async () => {
        const actualData = {
            serial: device.serialNumber, 
            name: editedName,
            propertyId: deviceProfile.state.location.state.property_id,
            networkId: deviceProfile.state.location.state.network_id,
            token: getToken()
          }
        const res = await changeDeviceName(actualData);
        if (res.error) {
            if (res.error.status===500) {
                showToast(false, 'ⓘ', 'Something went wrong, please try again');
            } else if (res.error.status===401) {
                showToast(false, 'ⓘ', 'Access Denied');
            } else {
                showToast(false, 'ⓘ', 'Something went wrong, please try again');
            }
        }
        refreshDeviceProfileData();
        setIsEditMode(false);
    };

    const handleRefresh = async () => {
        setRefreshLoader("Loading...");
        const actualData = {
            deviceId: deviceProfile.state.row.id,
            networkId: deviceProfile.state.location.state.network_id,
            propertyId: deviceProfile.state.location.state.property_id,
            token: getToken()
          }
        await refreshDeviceDetail(actualData);
        setRefreshLoader("Refresh");
    };

    const handleSyncTags = async () => {
        const actualData = {
            data:{"network":deviceProfile.state.location.state.network_id},
            token: getToken()
          }
        await syncTagsList(actualData);
    };

    const refreshDeviceProfileData = async () => {
        setRefreshLoader("Loading...");
        const actualData = {
            propertyId: deviceProfile.state.location.state.property_id,
            deviceId: device.id, 
            networkId: deviceProfile.state.location.state.network_id,
            serial:deviceProfile.state.row.serialNumber,
            organisationId: deviceProfile.state.location.state.organisation_id,
            token: getToken()
        }
        const res = await refreshDeviceProfile(actualData);
        if (res.data) {
            setProfile(res.data.profile.profile);
            setDevice(res.data.profile.device[0]);
            setUserNetwork(res.data.profile.userNetwork);
            setSingleAppModeProfile(res.data.profile.propertyNetwork.tag_dv);
            setMaintenanceAppModeProfile(res.data.profile.propertyNetwork.tag_maintenance);
            setEditedName(res.data.profile.device[0].name)
            setDeviceTag(res.data.profile.tags);
            setDeviceTagParam(res.data.profile.device[0].tags)
            setInstalledApp(res.data.profile.appDetails)
            setRefreshLoader("Refresh");
        }  
    };

    const handleSearchDevice = async () => {
        setNewDeviceSerialError("");
        setNewDevice("");
        if (!newDeviceSerial.trim()) {
            setNewDeviceSerialError("Enter a Serial Number");
        }
        if (newDeviceSerial.toUpperCase().trim() === (deviceProfile.state.row.serialNumber).toUpperCase()) {
            setNewDeviceSerialError("Enter a different Serial Number");
        }
        if (!newDeviceSerial.trim() || newDeviceSerial.toUpperCase().trim() === (deviceProfile.state.row.serialNumber).toUpperCase()){
            return;
        }
        if (!haveDeviceReplaceAccess){
            showToast(false, 'ⓘ', 'Access Denied');
            return
        }
    
        const actualData = {
            name: deviceProfile.state.location.state.name,
            propertyId: deviceProfile.state.location.state.property_id,
            networkId: deviceProfile.state.location.state.network_id,
            serial:newDeviceSerial,
            token: getToken()
          }
          const res = await searchDevice(actualData);
          if (res.data) {
            setNewDevice(res.data.profile.device);
            setNewDeviceNetwork(res.data.profile.deviceNetworkId);
            if (res.data.profile.device.length === 0){
                setNewDeviceSerialError("Device not found");
            }
          }  
    };

    const handleAskReplaceDevice = () => {
        setDeviceNote("");
        setDeviceRemark("");
        setOpenReplace(true);
    }

    const handleReplaceDevice = async () => {
        setOpen(false);
        const tagsToRemove = [singleAppModeProfile, maintenanceAppModeProfile]; 
        const updatedTags = device.tags.filter(tag => !tagsToRemove.includes(tag));
        const actualData = {
            data:{
                "property_id":deviceProfile.state.location.state.property_id,
                "current_device_network":deviceProfile.state.location.state.network_id,
                "new_device_network":newDeviceNetwork,
                "old_device_serial":device.serialNumber,
                "new_device_serial":newDevice.serialNumber,
                "new_device_name":device.name,
                "new_device_tags":updatedTags,
                "old_device_notes":deviceRemark
              },
            token: getToken()
          }
          const res = await replaceDevice(actualData);
          if (res.error) {
            if (res.error.status===500) {
                showToast(false, 'ⓘ', 'Something went wrong, please try again');
            } else if (res.error.status===401) {
                showToast(false, 'ⓘ', 'Access Denied');
            } else {
                showToast(false, 'ⓘ', 'Something went wrong, please try again');
            }
          }
          if (res.data) {
            showToast(true, '✔', 'Device replaced');
            setTimeout(() => {
              setOpen(false);
              navigate('/cloud/devices', { state: data });
            }, 2500);
          } 
          if (res.data===null) {
            showToast(true, '✔', 'Device replaced');
            setTimeout(() => {
              setOpen(false);
              navigate('/cloud/devices', { state: data });
            }, 2500);
          }
    };

    useEffect(() => {
        try {
            setHaveDeviceReplaceAccess(userAccessData.data.have_device_replace_access)
            setHaveUpdateTagAccess(userAccessData.data.have_update_tag_access)
            setHaveMigrateDeviceNetworkAccess(userAccessData.data.have_migrate_device_network_access)
        } catch(error) {
            console.log(error)
        }
        if (deviceProfileError) {
            if (deviceProfileError.status === 401) {
                showToast(false, 'ⓘ', 'Access Denied');
            } else {
                showToast(false, 'ⓘ', 'Something went wrong, server error');
            }
        } 
        if (deviceProfileData && deviceProfileIsSuccess) {
            setProfile(deviceProfileData.profile.profile);
            setDevice(deviceProfileData.profile.device[0]);
            setUserNetwork(deviceProfileData.profile.userNetwork);
            setSingleAppModeProfile(deviceProfileData.profile.propertyNetwork.tag_dv);
            setMaintenanceAppModeProfile(deviceProfileData.profile.propertyNetwork.tag_maintenance);
            setEditedName(deviceProfileData.profile.device[0].name);
            setDeviceTag(deviceProfileData.profile.tags);
            setDeviceTagParam(deviceProfileData.profile.device[0].tags)
            setInstalledApp(deviceProfileData.profile.appDetails)
            handleRefresh();
            setLoading(false);
        }
    }, [deviceProfileData, deviceProfileIsSuccess, deviceProfileError]); 
    
    const showToast = (status, symbol, message) => {
        setToasterData({
            trigger: true,
            status,
            symbol,
            message,
        });

        setTimeout(() => {
        setToasterData((prev) => ({
            ...prev,
            trigger: false,
        }));
        }, 5000); 
    };

  return (
    <>
        <div>
            <Dialog
            open={open}
            onClose={handleClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            >
            <DialogTitle id="alert-dialog-title">
                {popupTitle}
            </DialogTitle>
            <DialogContent>
                <Box
                    noValidate
                    component="form"
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        m: 'auto',
                        width: 'fit-content',
                    }}
                >
                    <img width={popupWidth} src={popupLogo} alt="" />
                </Box>
                {popupWidth===0 && (
                    <>
                        <FormGroup>
                            <FormControlLabel
                                control={
                                <Checkbox
                                    checked={message === "To troubleshoot iPad settings"}
                                    value={message}
                                    onChange={handleCheckboxChange}
                                    name="To troubleshoot iPad settings"
                                />
                                }
                                label="To troubleshoot iPad settings"
                            />
                            <FormControlLabel
                                control={
                                <Checkbox
                                    checked={message === "Need to replace iPad"}
                                    value={message}
                                    onChange={handleCheckboxChange}
                                    name="Need to replace iPad"
                                />
                                }
                                label="Need to replace iPad"
                            />
                            <FormControlLabel
                                control={
                                <Checkbox
                                    checked={message === "Other"}
                                    value={message}
                                    onChange={handleCheckboxChange}
                                    name="Other"
                                />
                                }
                                label="Other"
                            />
                            <TextareaAutosize
                                aria-label="empty textarea"
                                placeholder="Type Remark..."
                                style={{ width: '100%', marginTop: 20}}
                                disabled= {message === "Other" ? 0:1}  
                                minRows={4} 
                                maxRows={6}
                                onChange={(event) => setRemark(event.target.value)}
                            />
                        </FormGroup>
                    </>
                )}
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose} autoFocus>
                    Cancel
                </Button>
                {singleAppEnable && (popupWidth===0 ? (
                    <Button onClick={() => handleSingleAppMode("delete")} disabled={!remark?1:0}>
                        done
                    </Button>
                ):(
                    <Button onClick={() => handleSingleAppMode("add")}>
                        yes
                    </Button>
                ))}

                {deviceNetwork && popupWidth===0 && (
                    <Button onClick={() => handleChangeNetwork()}  disabled={!remark?1:0}>
                        done
                    </Button>
                )}

                {deviceTagPopup && (
                    <Button onClick={() => handleUpdateTag()}  disabled={!remark?1:0}>
                        done
                    </Button>
                )}

            </DialogActions>
            </Dialog>
        </div>

        <div>
            <Dialog
            open={openReplace}
            onClose={handleClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            >
            <DialogTitle id="alert-dialog-title">
                Reason for Device Replacement
            </DialogTitle>
            <DialogContent>
                <FormGroup>
                    <FormControlLabel
                        control={
                        <Checkbox
                            checked={deviceNote === "Broken Screen"}
                            value="Broken Screen"
                            onChange={(event) => handleDeviceReplaceCheckbox(event)}
                            name="Broken Screen"
                        />
                        }
                        label="Broken Screen"
                    />
                    <FormControlLabel
                        control={
                        <Checkbox
                            checked={deviceNote === "Missing from Guest Room"}
                            value="Missing from Guest Room"
                            onChange={(event) => handleDeviceReplaceCheckbox(event)}
                            name="Missing from Guest Room"
                        />
                        }
                        label="Missing from Guest Room"
                    />
                    <FormControlLabel
                        control={
                        <Checkbox
                            checked={deviceNote === "Other"}
                            value="Other"
                            onChange={(event) => handleDeviceReplaceCheckbox(event)}
                            name="Other"
                        />
                        }
                        label="Other"
                    />
                    <TextareaAutosize
                        aria-label="empty textarea"
                        placeholder="Type Remark..."
                        style={{ width: '100%', marginTop: 20}}
                        disabled= {deviceNote === "Other" ? 0:1}  
                        minRows={4} 
                        maxRows={6}
                        onChange={(event) => setDeviceRemark(event.target.value)}
                    />
                </FormGroup>
            </DialogContent>

            <DialogActions>
                <Button onClick={handleClose} autoFocus>
                    Cancel
                </Button>
                <Button onClick={() => handleReplaceDevice()} disabled={!deviceRemark?1:0}>
                    done
                </Button>
            </DialogActions>
            </Dialog>
        </div>

        <div>
            <Dialog
                open={openDoc}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                maxWidth="md" 
            >
                <DialogContent>
                    <Carousel showThumbs={false}>
                        {images.map((image, index) => (
                            <div key={index}>
                            <Paper elevation={3}>
                                <img
                                src={image}
                                alt={`Slide ${index}`}
                                style={{ width: '100%', height: 'auto', objectFit: 'cover' }}
                                />
                            </Paper>
                            </div>
                        ))}
                    </Carousel>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose} autoFocus>
                        Cancel
                    </Button>
                </DialogActions>
            </Dialog>
        </div>

        {toasterData.trigger && (
            <Toaster
            trigger={toasterData.trigger}
            status={toasterData.status}
            symbol={toasterData.symbol}
            message={toasterData.message}
            />
        )}

        {loading ? (
            <>
                <Grid item xs={12} sm={6} md={5} xl={5}>

                    <Card variant="outlined"
                        sx={{
                            height: '100%',
                            border: 1,
                            borderRadius: '8px',
                            borderColor: '#f2f0eb',
                            borderLeft: 5,
                            borderLeftColor: '#D8D9DA'
                            }}
                        >
                        <Skeleton sx={{m:3}} animation="wave" height={50} width='50%' />
                        <Skeleton sx={{m:2}} animation="wave" height={30} />
                        <Skeleton sx={{m:2}} animation="wave" height={30} />
                        <Skeleton sx={{m:2}} animation="wave" height={30} />
                        <Skeleton sx={{m:2}} animation="wave" height={30} />
                        <Skeleton sx={{m:2}} animation="wave" height={30} />
                        <Skeleton sx={{m:2}} animation="wave" height={30} />
                        <Skeleton sx={{m:2}} animation="wave" height={30} />
                        <Skeleton sx={{m:2}} animation="wave" height={30} />
                        <Skeleton sx={{m:2}} animation="wave" height={30} />
                        <Skeleton sx={{m:2}} animation="wave" height={30} />
                        <Skeleton sx={{m:2}} animation="wave" height={70} />
                    </Card>
                </Grid>
                <Grid item xs={12} sm={6} md={7} xl={7}>
                    <Grid sx={{mb:4}}>
                        <Card variant="outlined"
                            sx={{
                                height: '100%',
                                border: 1,
                                borderRadius: '8px',
                                borderColor: '#f2f0eb',
                                borderLeft: 5,
                                borderLeftColor: '#D8D9DA'
                                }}
                            >
                            <Skeleton sx={{m:3}} animation="wave" height={50} width='10%' />
                            <Skeleton sx={{m:2}} animation="wave" height={70} />
                            <Skeleton sx={{m:2}} animation="wave" height={40} width='50%' />
                            <Skeleton sx={{m:2}} animation="wave" height={40} width='50%' />
                            <Skeleton sx={{m:2}} animation="wave" height={30} />
                        </Card>
                    </Grid>

                    <Grid>
                        <Card variant="outlined"
                            sx={{
                                height: '100%',
                                border: 1,
                                borderRadius: '8px',
                                borderColor: '#f2f0eb',
                                borderLeft: 5,
                                borderLeftColor: '#D8D9DA'
                                }}
                            >
                            <Skeleton sx={{m:3}} animation="wave" height={50} width='20%' />
                            <Skeleton sx={{m:2}} animation="wave" height={30} />
                            <Skeleton sx={{m:2}} animation="wave" height={70} />
                            <Skeleton sx={{m:2}} animation="wave" height={30} />
                        </Card>
                    </Grid>
                </Grid>
            </>
        ):(
            <>
                <Grid item xs={12} sm={6} md={5} xl={5}>
                    <Card variant="outlined"
                        sx={{
                            height: '100%',
                            border: 1,
                            borderRadius: '8px',
                            borderColor: '#f2f0eb',
                            borderLeft: 5,
                            borderLeftColor: '#A8A196'
                            }}
                        >
                        <CardContent>
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '5%' }}>
                                <Typography variant="h6" gutterBottom>
                                    {device.name}
                                </Typography>
                                <button
                                    onClick={() => { handleRefresh(); refreshDeviceProfileData(); handleSyncTags();}}
                                    style={{
                                        color: '#FFF',
                                        padding: '4px 8px',
                                        marginLeft: '4px',
                                        borderRadius: '16px',
                                        border: '1px solid #A8A196',
                                        backgroundColor: '#A8A196',
                                        ":hover": {
                                            backgroundColor: "#7D7463",
                                            borderColor: '#7D7463',
                                    }}}>{refreshLoader}
                                </button>
                            </div>
                            <Table>
                                <TableBody>
                                    <TableRow>
                                        <TableCell sx={cellStyle}>Name:</TableCell>
                                        {isEditMode ? (
                                        <TableCell sx={cellStyle}>
                                            <input
                                                type="text"
                                                value={editedName}
                                                onChange={(event) => setEditedName(event.target.value)}
                                                style={{
                                                    border: '1px solid #A8A196',
                                                    borderRadius: '16px',
                                                }}/>
                                            <button 
                                                onClick={handleSaveClick}
                                                style={{
                                                    color: '#FFF',
                                                    padding: '3px 12px',
                                                    marginLeft: '4px',
                                                    borderRadius: '16px',
                                                    border: '1px solid #A8A196',
                                                    backgroundColor: '#A8A196',
                                                    ":hover": {
                                                        backgroundColor: "#7D7463",
                                                        borderColor: '#7D7463',
                                                }}}><Icon icon="mingcute:check-fill" />
                                            </button>
                                            <button 
                                                onClick={() => setIsEditMode(false)}
                                                style={{
                                                    color: '#FFF',
                                                    padding: '3px 12px',
                                                    marginLeft: '4px',
                                                    borderRadius: '16px',
                                                    border: '1px solid #A8A196',
                                                    backgroundColor: '#A8A196',
                                                    ":hover": {
                                                        backgroundColor: "#7D7463",
                                                        borderColor: '#7D7463',
                                                }}}><Icon icon="akar-icons:cross" />
                                            </button>
                                        </TableCell>
                                        ) : (
                                        <TableCell sx={cellStyle}>
                                            {editedName}&nbsp;&nbsp;
                                            <button 
                                                style={{
                                                    color: '#FFF',
                                                    padding: '0px 10px',
                                                    marginRight: '4px',
                                                    borderRadius: '16px',
                                                    border: '1px solid #A8A196',
                                                    backgroundColor: '#A8A196',
                                                    ":hover": {
                                                        backgroundColor: "#7D7463",
                                                        borderColor: '#7D7463',
                                                }}}
                                                onClick={handleEditClick}>
                                                <Icon height={15} icon="tabler:edit" />
                                            </button>
                                        </TableCell>
                                        )}
                                    </TableRow>
                                    <TableRow>
                                        <TableCell sx={cellStyle}>Device&nbsp;Notes:</TableCell>
                                        <TableCell sx={cellStyle}>{device.notes}</TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell sx={cellStyle}>Model:</TableCell>
                                        <TableCell sx={cellStyle}>{device.systemModel}</TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell sx={cellStyle}>OS:</TableCell>
                                        <TableCell sx={cellStyle}>{device.osName}</TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell sx={cellStyle}>Serial:</TableCell>
                                        <TableCell sx={cellStyle}>{device.serialNumber}</TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell sx={cellStyle}>Device&nbsp;IP:</TableCell>
                                        <TableCell sx={cellStyle}>{device.ip}</TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell sx={cellStyle}>WiFi&nbsp;SSID:</TableCell>
                                        <TableCell sx={cellStyle}>{device.ssid}</TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell sx={cellStyle}>MAC&nbsp;Address:</TableCell>
                                        <TableCell sx={cellStyle}>{device.wifiMac}</TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell sx={cellStyle}>Single&nbsp;App:</TableCell>
                                        {device.kioskAppName ? (<TableCell sx={{ borderBottom: 'none', paddingY: 1, color:'#96C291', fontWeight: 'bold'}}>Lock&nbsp;({device.kioskAppName}) </TableCell>):(<TableCell sx={{borderBottom: 'none', paddingY: 1, color:'#FFB7B7', fontWeight: 'bold'}}>Unlock</TableCell>)}
                                    </TableRow>
                                    <TableRow>
                                        <TableCell sx={cellStyle}>Last&nbsp;MDM&nbsp;Checkin:</TableCell>
                                        <TableCell sx={cellStyle}>{formatTimestamp(device.lastConnected)}</TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell sx={cellStyle}>Battery:</TableCell>
                                        <TableCell sx={cellStyle}><LinearProgressWithLabel value={parseFloat(device.batteryEstCharge)} /></TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell sx={cellStyle}>Device&nbsp;storage:</TableCell>
                                        <TableCell sx={cellStyle}>{((device.deviceCapacity/1073741824).toFixed(0)-device.availableDeviceCapacity/1073741824).toFixed(0)}GB&nbsp;/&nbsp;{(device.deviceCapacity/1073741824).toFixed(0)}GB</TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell sx={cellStyle}>Location:</TableCell>
                                        <TableCell sx={cellStyle}>{device.location}</TableCell>
                                    </TableRow>
                                </TableBody>
                            </Table>
                        </CardContent>
                    </Card>
                </Grid>

                <Grid item xs={12} sm={6} md={7} xl={7}> 
                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={12} md={12} xl={12}>
                            <Card variant="outlined" 
                                sx={{
                                    border: 1,
                                    borderRadius: '8px',
                                    borderColor: '#f2f0eb',
                                    borderLeft: 5,
                                    borderLeftColor: '#A8A196',
                                }}      
                                >
                                <CardContent>
                                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 10 }}>
                                        <Typography variant="h6" gutterBottom>
                                            Tags
                                        </Typography>
                                        {isEditTagMode ? (
                                        <div>
                                            <Button
                                                onClick={handleCloseEditTagClick}
                                                sx={{
                                                    color: '#FFF',
                                                    padding: '0px 1px',
                                                    marginRight: '4px',
                                                    borderRadius: '16px',
                                                    border: '1px solid #A8A196',
                                                    backgroundColor: '#A8A196',
                                                    ":hover": {
                                                        backgroundColor: "#7D7463",
                                                        borderColor: '#7D7463',
                                                }}}>Cancel
                                            </Button>
                                            <Button
                                                onClick={handleAskUpdateTagPopup}
                                                sx={{
                                                    color: '#FFF',
                                                    padding: '0px 1px',
                                                    borderRadius: '16px',
                                                    border: '1px solid #A8A196',
                                                    backgroundColor: '#A8A196',
                                                    ":hover": {
                                                        backgroundColor: "#7D7463",
                                                        borderColor: '#7D7463',
                                                }}}>Save
                                            </Button>
                                        </div>
                                        ):(
                                            <Button
                                                onClick={handleEditTagClick}
                                                sx={{
                                                    color: '#FFF',
                                                    padding: '4px 8px',
                                                    borderRadius: '16px',
                                                    border: '1px solid #A8A196',
                                                    backgroundColor: '#A8A196',
                                                    ":hover": {
                                                        backgroundColor: "#7D7463",
                                                        borderColor: '#7D7463',
                                                }}}><Icon height={15} icon="tabler:edit" />
                                            </Button>
                                        )}
                                    </div>

                                    {isEditTagMode ? (
                                        <Autocomplete
                                            multiple
                                            id="tags-outlined"
                                            fullWidth
                                            size="medium"
                                            options={filterSelectedOptions(deviceTag, deviceTagParam)}
                                            getOptionLabel={(option) => option}
                                            defaultValue={device.tags}
                                            // value={deviceTagParam}
                                            freeSolo
                                            onChange={(event, newValue) => setDeviceTagParam(newValue)}
                                            renderInput={(params) => (
                                                <TextField
                                                {...params}
                                                label="Tags"
                                                />
                                            )}
                                        />
                                    ) : (
                                        <>
                                            {device.tags.map((tag, index) => (
                                                <Paper key={index} 
                                                    sx={{
                                                        backgroundColor: '#F1EFEF',
                                                        color: '#A8A196',
                                                        padding: theme.spacing(1, 2),
                                                        margin: theme.spacing(0.5),
                                                        borderRadius: '16px', 
                                                        display: 'inline-flex', 
                                                        alignItems: 'center',
                                                    }}
                                                    >
                                                    <Typography variant="body2">{tag}</Typography>
                                                </Paper>
                                            ))}

                                            {device.tags.length === 0 && ( 
                                                <Typography sx={{
                                                    fontSize: 14, 
                                                    backgroundColor: '#F1EFEF',
                                                    color: '#A8A196',
                                                    padding: theme.spacing(1, 2),
                                                    margin: theme.spacing(0.5),
                                                    borderRadius: '16px', 
                                                    // display: 'inline-flex', 
                                                    alignItems: 'center',
                                                    textAlign:'center'
                                                }}>
                                                    No Tags Assigned
                                                </Typography>
                                            )}
                                        </>
                                    )}

                                    <Grid container sx={{marginY:3, marginLeft:2}}>
                                        <Grid item xs={12}>
                                            <FormControlLabel
                                                control={
                                                <Switch
                                                    color="primary"
                                                    disabled = {device.tags.includes(maintenanceAppModeProfile)}
                                                    checked={device.tags.includes(singleAppModeProfile) ? 1:0}
                                                    onChange={(event) => handleAskSingleAppModePopup(event.target.checked)}
                                                />
                                                }
                                                label="Single App Mode"
                                            />
                                        </Grid>
                                    </Grid>
                                    
                                    <Typography sx={{fontSize: 14}}>
                                        Note: The above modes are mutually exclusive, disable one to enable the other.
                                    </Typography>
                                </CardContent>
                            </Card>
                        </Grid>
                        <Grid item xs={12} sm={12} md={12} xl={12}>
                            <Card variant="outlined" 
                                sx={{
                                    height: '100%',
                                    border: 1,
                                    borderRadius: '8px',
                                    borderColor: '#f2f0eb',
                                    borderLeft: 5,
                                    borderLeftColor: '#A8A196',
                                }}      
                                >
                                <CardContent>

                                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 10 }}>
                                        <Typography variant="h6" gutterBottom mb={2}>
                                            Replace Device
                                        </Typography>
                                        <Button
                                            onClick={handleDocOpen}
                                            sx={{
                                            //     color: '#FFF',
                                            //     padding: '4px 8px',
                                            //     borderRadius: '16px',
                                            //     border: '1px solid #A8A196',
                                            //     backgroundColor: '#A8A196',
                                            //     ":hover": {
                                            //         backgroundColor: "#7D7463",
                                            //         borderColor: '#7D7463',
                                            // }
                                            }}><Icon height={30} icon="fluent:info-16-regular" />
                                        </Button>
                                    </div>

                                    <Typography sx={{fontSize: 14, marginBottom: 3}} >
                                        Use this module to replace an in-room iPad device in-case it gets damaged or stolen. Type-in the serial number of the new iPad below-
                                    </Typography>

                                    {newDevice.length === 0 && (
                                    <Box
                                        noValidate
                                        component="form"
                                        sx={{
                                            display: 'flex',
                                            flexDirection: 'column',
                                            m: 'auto',
                                            mb: '3%',
                                            width: 'fit-content',
                                        }}
                                    >
                                        <img width={200} src={"../../assets/app/replaceDevice.png"} alt="" />
                                    </Box>
                                    )}
                                    
                                    <Grid container spacing={1} xs={12}>
                                        <Grid item xs={12} sm={9} md={9} xl={7}>
                                            <FormControl fullWidth>
                                                <TextField
                                                    label="Serial Number"
                                                    variant="outlined"
                                                    size="small"
                                                    value={newDeviceSerial}
                                                    helperText={newDeviceSerialError}
                                                    error={Boolean(newDeviceSerialError)}
                                                    autoComplete="off"
                                                    onChange={(event) => {setNewDeviceSerial(event.target.value); setNewDeviceSerialError(""); setNewDevice("");}}
                                                />
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs={12} sm={3} md={3} xl={5}>
                                            <FormControl fullWidth>
                                                <Button
                                                    onClick={() => (handleSearchDevice())}
                                                    sx={{
                                                        color: '#FFF',
                                                        border: 1,
                                                        borderColor: '#A8A196',
                                                        bgcolor: '#A8A196',
                                                        ":hover": {
                                                        bgcolor: "#7D7463",
                                                        borderColor: '#7D7463',
                                                        }}
                                                    }>
                                                Search
                                                </Button>
                                            </FormControl>
                                        </Grid>
                                    </Grid>

                                    {newDevice.length !== 0 && (
                                        <>
                                        <TableContainer component={Paper} sx={{marginY:3}}>
                                            <Table sx={{ minWidth: 650 }} size="small" aria-label="a dense table">
                                                <TableHead>
                                                    <TableRow>
                                                        <TableCell>Name</TableCell>
                                                        <TableCell align="center">Serial</TableCell>
                                                        <TableCell align="center">WiFi&nbsp;SSID</TableCell>
                                                        <TableCell align="center">MAC&nbsp;Address</TableCell>
                                                    </TableRow>
                                                </TableHead>

                                                <TableBody>
                                                    <TableRow>
                                                        <TableCell>{newDevice.name}</TableCell>
                                                        <TableCell align="center">{newDevice.serialNumber}</TableCell>
                                                        <TableCell align="center">{newDevice.ssid}</TableCell>
                                                        <TableCell align="center">{newDevice.wifiMac}</TableCell>
                                                    </TableRow>
                                                    <TableRow>
                                                        {newDevice.length === 0 && (
                                                            <TableCell colSpan={8} align="center">
                                                            No Device Found
                                                            </TableCell>
                                                        )}
                                                    </TableRow>
                                                </TableBody>
                                            </Table>
                                        </TableContainer>
                                        <Box display="flex" justifyContent="center">
                                            <Grid container xs={12} sm={8} md={5} xl={2}>
                                                <FormControl fullWidth>
                                                    <Button
                                                    onClick={() => handleAskReplaceDevice()}
                                                    sx={{
                                                        color: '#FFF',
                                                        border: 1,
                                                        borderColor: '#A8A196',
                                                        bgcolor: '#A8A196',
                                                        ":hover": {
                                                        bgcolor: "#7D7463",
                                                        borderColor: '#7D7463',
                                                        }}
                                                    }
                                                    >
                                                    Initiate Replacement
                                                    </Button>
                                                </FormControl> 
                                            </Grid>
                                        </Box>
                                        </>
                                    )}
                                </CardContent>
                            </Card>
                        </Grid>
                        <Grid item xs={12} sm={12} md={12} xl={12}>
                            <Card variant="outlined" 
                                sx={{
                                    border: 1,
                                    borderRadius: '8px',
                                    borderColor: '#f2f0eb',
                                    borderLeft: 5,
                                    borderLeftColor: '#A8A196',
                                }}      
                            >
                                <CardContent>
                                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 10 }}>
                                        <Typography variant="h6" gutterBottom>
                                        Migrate Device
                                        </Typography>
                                    </div>
                                    <Grid container spacing={1} xs={12}>
                                        <Grid item xs={12} sm={9} md={9} xl={7}>
                                            <FormControl fullWidth size="small">
                                                <InputLabel id="demo-select-small-label">Move to</InputLabel>
                                                <Select
                                                    labelId="demo-select-small-label"
                                                    id="demo-select-small"
                                                    value={deviceNetwork}
                                                    label="moveTo"
                                                    onChange={(event) => [setDeviceNetwork(event.target.value), setDeviceNetworkError("")]}
                                                    error={Boolean(deviceNetworkError)}
                                                >
                                                    {userNetwork
                                                        .map(item => (
                                                            <MenuItem value={item.network_id} key={item.network_id}>{item.network_name}</MenuItem>
                                                        ))
                                                    }
                                                </Select>
                                                <FormHelperText sx={{ color: '#EB4C49' }}>{deviceNetworkError}</FormHelperText>
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs={12} sm={3} md={3} xl={5}>
                                            <FormControl fullWidth>
                                                <Button
                                                    onClick= {handleAskChangeNetwork}
                                                    sx={{
                                                        color: '#FFF',
                                                        border: 1,
                                                        borderColor: '#A8A196',
                                                        bgcolor: '#A8A196',
                                                        ":hover": {
                                                            bgcolor: "#7D7463", 
                                                            borderColor: '#7D7463',
                                                        }}}
                                                        >
                                                    Move
                                                </Button>
                                            </FormControl>
                                        </Grid>
                                    </Grid>
                                </CardContent>
                            </Card>
                        </Grid>
                    </Grid>
                </Grid>

                {installedApp.length > 0 &&(
                    <>
                    <Grid item xs={12}>
                    <Typography variant="h5" color="text.secondary">
                        Installed&nbsp;Applications
                    </Typography>
                    </Grid>
                    <Grid item xs={12} sm={12} md={12} xl={12}>
                        <TableContainer
                            component={Paper} 
                            sx={{
                                border: 1,
                                borderRadius: '8px',
                                borderColor: '#f2f0eb',
                                borderLeft: 5,
                                borderLeftColor: '#A8A196',
                            }}>
                            <Table>
                                <TableHead>
                                    <TableRow>
                                        <TableCell>&nbsp;&nbsp;Name&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</TableCell>
                                        <TableCell align="center">Version</TableCell>
                                        <TableCell align="center">Managed</TableCell>
                                        <TableCell align="center">Size</TableCell>
                                        <TableCell align="center">Installed&nbsp;Date</TableCell>
                                        <TableCell align="center">Updated&nbsp;Date</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                {installedApp.map((row) => (
                                    <TableRow
                                        key={row.id}
                                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                    >
                                    <TableCell component="th" color="text.secondary" style={{ fontWeight: 'bold' }} scope="row">&nbsp;&nbsp;{row.name}</TableCell>
                                    <TableCell align="center">{row.shortVersion}({row.version})</TableCell>
                                    <TableCell align="center">{row.isManaged? 'Yes' : 'No'}</TableCell>
                                    <TableCell align="center">{(row.bundleSize/1048576).toFixed(0)}&nbsp;MB</TableCell>
                                    <TableCell align="center">{dayjs(row.installedAt).format('DD MMM YYYY HH:mm')}</TableCell>
                                    <TableCell align="center">{dayjs(row.updatedAt).format('DD MMM YYYY HH:mm')}</TableCell>
                                    </TableRow>
                                ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Grid>
                    </>
                )}

                {profile.length > 0 &&(
                    <Grid item xs={12}>
                    <Typography variant="h5" color="text.secondary">
                        Installed&nbsp;Profiles
                    </Typography>
                    </Grid>
                )}

                {profile.map((profile) => (
                    <Grid item xs={12} sm={6} md={4} xl={3} key={profile.name}>
                        <Card variant="outlined" 
                            sx={{
                                border: 1,
                                borderRadius: '8px',
                                borderColor: '#f2f0eb',
                                borderLeft: 5,
                                borderLeftColor: '#A8A196',
                            }}      
                        >
                            <CardContent>
                                <Typography variant="h6" gutterBottom>
                                    {profile.name}
                                </Typography>
                                <Typography variant="body2" color="textSecondary">
                                    Profile ID: {profile.id}
                                </Typography>
                                <Typography variant="body2" color="textSecondary">
                                    Managed: {profile.isManaged ? 'Yes' : 'No'}
                                </Typography>
                                <Typography variant="body2" color="textSecondary">
                                    Version: {profile.version}
                                </Typography>
                            </CardContent>
                        </Card>
                    </Grid>
                ))}
            </>
        )}
    </>
  );
}
Profile.propTypes = {
    deviceProfile: PropTypes.string.isRequired
}
